import { Provider } from "react-redux";
import Header from "./components/Header";
import MainBody from "./components/MainBody";
import store from "./redux/store";

export default function App() {
  return (
    <>
      <Provider store={store}>
        <Header />
        <MainBody />
      </Provider>
    </>
  );
}
